function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { ConnectionInterface, DefaultHandlerProvider, RecordSource, RelayFeatureFlags } from 'relay-runtime';
import LiveResolverStore

// @ts-ignore
from 'relay-runtime/lib/store/experimental-live-resolvers/LiveResolverStore';
import invariant from 'tiny-invariant';
import warning from 'tiny-warning';
import { fg } from '@atlaskit/platform-feature-flags';
import RelayDataID from '@atlassian/relay-data-id';
import RelayMissingFieldHandlers from '@atlassian/relay-missing-field-handlers';
import { createNetwork, network as defaultNetwork } from '@atlassian/relay-network';
import RelayScheduler from '@atlassian/relay-scheduler';
var createStore = function createStore(source, options) {
  RelayFeatureFlags.ENABLE_RELAY_RESOLVERS = true;
  return new LiveResolverStore(source, options);
};
export function getDefaultRelayEnvironmentConfig(_ref) {
  var log = _ref.log,
    requiredFieldLogger = _ref.requiredFieldLogger,
    network = _ref.network,
    networkOptions = _ref.networkOptions,
    getDataID = _ref.getDataID,
    recordSource = _ref.recordSource;
  return {
    configName: 'Atlassian Graphql Gateway',
    network: network || getEnvironmentNetwork(networkOptions),
    store: createStore(recordSource || new RecordSource(), {
      log: log !== null && log !== void 0 ? log : undefined,
      getDataID: getDataID !== null && getDataID !== void 0 ? getDataID : RelayDataID
    }),
    log: log,
    relayFieldLogger: requiredFieldLogger,
    getDataID: getDataID !== null && getDataID !== void 0 ? getDataID : RelayDataID,
    scheduler: RelayScheduler,
    missingFieldHandlers: RelayMissingFieldHandlers
  };
}
export function getSharedRelayEnvironmentConfig(_ref2) {
  var log = _ref2.log,
    requiredFieldLogger = _ref2.requiredFieldLogger,
    networkOptions = _ref2.networkOptions,
    network = _ref2.network,
    getDataID = _ref2.getDataID,
    recordSource = _ref2.recordSource;
  return {
    configName: 'Atlassian Shared Graphql Gateway',
    network: network || getEnvironmentNetwork(networkOptions),
    store: createStore(recordSource || new RecordSource(), {
      log: log !== null && log !== void 0 ? log : undefined,
      getDataID: 'getDataID' in arguments[0] ? getDataID : RelayDataID
    }),
    log: log,
    relayFieldLogger: requiredFieldLogger,
    getDataID: 'getDataID' in arguments[0] ? getDataID : RelayDataID,
    scheduler: RelayScheduler,
    missingFieldHandlers: RelayMissingFieldHandlers,
    handlerProvider: fg('platform_relay_config_deleteedge_handler') ? HandlerProvider : undefined
  };
}
function HandlerProvider(handle) {
  switch (handle) {
    case 'deleteEdge':
      return DeleteEdgeHandler;
    default:
      return DefaultHandlerProvider(handle);
  }
}
var getEnvironmentNetwork = function getEnvironmentNetwork(networkOptions) {
  if (networkOptions) {
    return createNetwork(networkOptions);
  }
  return defaultNetwork;
};

// Copied from ConnectionHandler.deleteNode implementation with a single change in behaviour:
// nodeID is compared to the `id` field of the node, rather than node.getDataID().
// This is a sane thing to do within the scope of a single connection even in the light of
// id collisions present in AGG for the entities of different types.
// Such change makes @deleteEdge directive usable again.
function deleteNode(record, nodeID) {
  var _ConnectionInterface$ = ConnectionInterface.get(),
    EDGES = _ConnectionInterface$.EDGES,
    NODE = _ConnectionInterface$.NODE;
  var edges = record.getLinkedRecords(EDGES);
  if (!edges) {
    return;
  }
  var nextEdges;
  for (var ii = 0; ii < edges.length; ii++) {
    var edge = edges[ii];
    var node = edge && edge.getLinkedRecord(NODE);
    // N.B. node.getValue('id') instead of node.getDataID()
    if (node != null && node.getValue('id') === nodeID) {
      if (nextEdges === undefined) {
        nextEdges = edges.slice(0, ii);
      }
    } else if (nextEdges !== undefined) {
      nextEdges.push(edge);
    }
  }
  if (nextEdges !== undefined) {
    record.setLinkedRecords(nextEdges, EDGES);
  }
}

// Copied from DeleteEdgeHandler implementation in Relay with a single change in behaviour:
// it calls deleteNode above instead of ConnectionHandler.deleteNode.
var DeleteEdgeHandler = {
  update: function update(store, payload) {
    var record = store.get(payload.dataID);
    if (record == null) {
      return;
    }
    // @types/relay-runtime is broken, handleArgs is present in the original Flow types.
    var connections = payload.handleArgs.connections;
    invariant(connections != null, 'MutationHandlers: Expected connection IDs to be specified.');
    var idOrIds = record.getValue(payload.fieldKey);
    var idList = Array.isArray(idOrIds) ? idOrIds : [idOrIds];
    idList.forEach(function (id) {
      if (typeof id === 'string') {
        var _iterator = _createForOfIteratorHelper(connections),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var connectionID = _step.value;
            var connection = store.get(connectionID);
            if (connection == null) {
              warning(false, "[Relay] The connection with id ".concat(connectionID, " doesn't exist."));
              continue;
            }
            deleteNode(connection, id);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    });
  }
};